import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FavoriteState {
  favIds: number[];
}

const initialState: FavoriteState = {
  favIds: JSON.parse(localStorage.getItem('favIds') || '[]'),
};

const favoriteSlice = createSlice({
  name: 'favorite',
  initialState,
  reducers: {
    addToFavorites: (state, action: PayloadAction<number>) => {
      state.favIds.push(action.payload);
      window.localStorage.setItem('favIds', JSON.stringify(state.favIds));
    },
    removeFromFavorites: (state, action: PayloadAction<number>) => {
      state.favIds = state.favIds.filter(id => id !== action.payload);
      window.localStorage.setItem('favIds', JSON.stringify(state.favIds));
    },
    replaceFavorites: (state, action: PayloadAction<number[]>) => {
      state.favIds = action.payload;
    },
  },
});

export const { addToFavorites, removeFromFavorites, replaceFavorites } = favoriteSlice.actions;
export default favoriteSlice.reducer;
